// src/components/Scoreboard.jsx
import React, { useContext } from 'react';
import { GameContext } from '../context/GameContext';

const Scoreboard = () => {
  const { gameState, socket } = useContext(GameContext);
  const bases = gameState?.state?.bases || {};
  const kodis = gameState?.state?.kodis || {};
  const players = gameState?.players || [];
  const currentPlayer = players.find(p => p.socketId === socket.id);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: '#f9fafb',
      padding: '8px 12px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      fontSize: '0.85rem',
      gap: '12px'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#1e40af',
        fontWeight: '600'
      }}>
        <span style={{ fontSize: '1rem' }}>🔵</span>
        <span>Team A: {bases.A || 0}</span>
      </div>
      <div style={{
        width: '1px',
        height: '20px',
        backgroundColor: '#d1d5db'
      }} />
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#dc2626',
        fontWeight: '600'
      }}>
        <span style={{ fontSize: '1rem' }}>🔴</span>
        <span>Team B: {bases.B || 0}</span>
      </div>
    </div>
  );
};

export default Scoreboard;
